import axios from 'axios';
import { HOPLA_URL } from '../config/config';

export const sendContact = async (
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    message: string,
    fromCoach: boolean
): Promise<void> => {
    await axios.post(HOPLA_URL + '/contact', {
        firstName,
        lastName,
        phone,
        email,
        message,
        fromCoach
    });
}